import { ClientReachMenuComponent } from '../main/main-menu.directive';

export const openMenuWithResult = async (
	menu: ClientReachMenuComponent | undefined,
	getResult: () => boolean
): Promise<boolean> => {
	if (!menu) {
		return false;
	}

	return await new Promise<boolean>((resolve) => {
		const sub = menu.closed$$.subscribe(() => {
			sub.unsubscribe();
			resolve(getResult());
		});
		menu.open();
	});
};
